import type React from 'react';
import { createContext, useContext } from 'react';

const RehydrationContext = createContext(false);

type RehydrationProviderProps = {
  isRehydrated: boolean;
  children: React.ReactNode;
};

export const RehydrationProvider = ({ isRehydrated, children }: RehydrationProviderProps) => (
  <RehydrationContext.Provider value={isRehydrated}>{children}</RehydrationContext.Provider>
);

export const useIsRehydrated = (): boolean => useContext(RehydrationContext);
